<template>
  <div>
    <slot v-if="!teste" name="original"></slot>
    <slot v-if="teste" name="teste"></slot>
  </div>
</template>
<script>
import TESTES from "../defaults/ab/testes";

export default {
  name: "TesteAB",
  props: {
    cookieNome: {
      type: String,
      required: true,
      validator: (nome) =>
        Object.keys(TESTES).some((teste) => TESTES[teste].nome === nome),
    },
    eventoNome: {
      type: String,
      default: () => this.cookieNome,
    },
    fluxoNome: {
      type: String,
      default: () => "teste_ab",
    },
    trackingNomeTeste: {
      type: String,
      default: () => "versão_teste",
    },
    trackingNomeOriginal: {
      type: String,
      default: () => "versão_original",
    },
    percentual: {
      type: Number,
      default: () => 50,
    },
    expiraEm: {
      type: Number,
      default: () => 60 * 60 * 24 * 30, // 30 dias
    },
  },
  data() {
    return {
      teste: false,
    };
  },
  created() {
    let percent = getCookie("escavador.ab." + this.cookieNome);
    if (!percent) {
      percent = this.getRandomInt(100);
      setCookie("escavador.ab." + this.cookieNome, percent, {
        expires: this.expiraEm,
        domain: `.${process.env.rootDomain}`,
        path: "/",
      });
    }
    this.teste = percent < this.percentual;
  },
  methods: {
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
  },
};
</script>
